import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
    static targets = ["form", "input", "button", "spinner"]

    submit(event) {
        if (this.inputTarget.value.trim() === "") {
            event.preventDefault();
            return;
        }
        this.buttonTarget.disabled = true;
        this.buttonTarget.classList.add("d-none");
        this.spinnerTarget.classList.remove("d-none");
    }
}
